var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFastdelivery(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "fastdelivery",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_706",
    "data-name": "Rectangle 706",
    width: 24,
    height: 24,
    transform: "translate(0.005 0.004)",
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_22",
    "data-name": "Group 22",
    transform: "translate(-0.005 -0.004)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_78174",
    "data-name": "Group 78174",
    transform: "translate(-0.299)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "fast-delivery",
    d: "M19.941,5.61,13.064,1.639a.633.633,0,0,0-.317-.085H8.852a.633.633,0,0,0,0,1.266h1.532L5.7,5.525H.633a.633.633,0,0,0,0,1.266H5.7l6.414,3.7v6.479L6.186,13.551a.633.633,0,0,0-.317-.085H.633a.633.633,0,1,0,0,1.266H5.7l6.73,3.886a.633.633,0,0,0,.633,0l6.877-3.971a.633.633,0,0,0,.317-.548V6.158a.633.633,0,0,0-.317-.548Zm-1.583.548L12.747,9.4,7.136,6.158l5.611-3.24ZM13.38,16.974V10.494l5.611-3.24v6.479ZM1.823,2.188a.633.633,0,0,1,.633-.633H6.551a.633.633,0,0,1,0,1.266H2.456a.633.633,0,0,1-.633-.633Zm.633,8.574a.633.633,0,1,1,0-1.266H5.748a.633.633,0,1,1,0,1.266Z",
    transform: "translate(2.304 1.449)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_43",
    "data-name": "Path 43",
    d: "M1.715,129.715a.857.857,0,1,0,0-1.715H.857a.857.857,0,1,0,0,1.715Z",
    transform: "translate(0.004 -118.137)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFastdelivery);
export default __webpack_public_path__ + "static/media/fastdelivery.43f2256dbee2c1ab0390fdd198e56439.svg";
export { ForwardRef as ReactComponent };